import React, { useContext, useEffect, useState } from "react";

import AdminDrawer from "../components/AdminDrawer";
import { loginContext, adminDrawerContext } from "../context/contexts";
import AddDevice from "../components/AddDevice";
import AddUser from "../components/AddUser";
import UserList from "../components/UserList";
import DeviceList from "../components/DeviceList";
import AdminSetting from "../components/AdminSetting";
import UserDetail from "../components/UserDetail";
import DeviceDetail from "../components/DeviceDetail";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import ManufacturedDevice from "../components/ManufacturedDevice";
import Grid from "@mui/material/Grid";
import Hublist from "../components/Hublist";
import HubDevices from "../components/HubDevices";
import AdminList from "../components/AdminList";
import Distributorlist from "../components/Distributorlist";
import ReplaceDevice from "../components/AdminComponent/ReplaceDevice";
import ChangeBillingType from "../components/AdminComponent/ChangeBillingType";
import CustomerBilling from "../components/CustomerBilling";
import OrganisationBilling from "../components/OrganisationBilling";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { boxStyle, headerStyle } from "../style/style";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";

export default function AdminPage() {
  const [buttonText, setbuttonText] = useState("Distributors");

  const context = useContext(loginContext);
  const history = useNavigate();

  // Check if viewing billing details
  const billingCustomerId = sessionStorage.getItem("billingCustomerId");

  useEffect(() => {
    if (
      sessionStorage.getItem("token") === "" ||
      !sessionStorage.getItem("token")
    ) {
      alert("Please log in to view this page!");
      history({ pathname: "/" });
    }
  }, [history]);

  return (
    <>
      {localStorage.getItem("role") === "ADMIN" ? (
        <>
          {billingCustomerId ? (
            // Full-width with sidebar
            <adminDrawerContext.Provider
              value={{
                setbuttonText: setbuttonText,
                buttonText: "Customer Billing", // Set to Customer Billing
              }}
            >
              <Box
                sx={{ fontFamily: "Roboto", fontSize: "24px", display: "flex" }}
              >
                <Grid container sx={{ width: "100%" }}>
                  <Grid item xs={6} md={4} lg={2}>
                    <AdminDrawer />
                  </Grid>
                  <Grid item xs={6} md={8} lg={10}>
                    <Box sx={{ width: "100%" }}>
                      <Card sx={boxStyle}>
                        <Card sx={headerStyle}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Button
                                startIcon={<ArrowBackIcon />}
                                onClick={() => {
                                  sessionStorage.removeItem(
                                    "billingCustomerId",
                                  );
                                  sessionStorage.removeItem(
                                    "billingCustomerName",
                                  );
                                  sessionStorage.removeItem("billingMonth");
                                  sessionStorage.removeItem("billingYear");
                                  sessionStorage.removeItem("billingFromUtc");
                                  sessionStorage.removeItem("billingToUtc");
                                  // Reset sidebar
                                  setbuttonText("Customer Billing");

                                  if (
                                    context &&
                                    context.page &&
                                    context.setpage
                                  ) {
                                    const resetPages = Object.keys(
                                      context.page,
                                    ).reduce((acc, key) => {
                                      acc[key] = false;
                                      return acc;
                                    }, {});
                                    context.setpage({
                                      ...resetPages,
                                      CustomerBilling: true,
                                    });
                                  }
                                }}
                                variant="outlined"
                              >
                                Back
                              </Button>
                              <span>
                                Billing Details for{" "}
                                {sessionStorage.getItem("billingCustomerName")}
                              </span>
                            </Box>
                          </Box>
                        </Card>
                      </Card>
                      <Card sx={boxStyle}>
                        <Box sx={{ width: "95%", mx: "auto", mt: 2, mb: 2 }}>
                          <OrganisationBilling
                            id={billingCustomerId}
                            customerDetails={{
                              company_name: sessionStorage.getItem(
                                "billingCustomerName",
                              ),
                            }}
                          />
                        </Box>
                      </Card>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </adminDrawerContext.Provider>
          ) : (
            // Normal sidebar layout
            <adminDrawerContext.Provider
              value={{
                setbuttonText: setbuttonText,
                buttonText: buttonText,
              }}
            >
              <Box
                sx={{
                  fontFamily: "Roboto",
                  fontSize: "24px",
                  display: "flex",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={6} md={4} lg={2}>
                    <AdminDrawer />
                  </Grid>
                  <Grid item xs={6} md={6} lg={10}>
                    {context.page.addDevice === true && <AddDevice />}
                    {context.page.addCustomer === true && <AddUser />}
                    {context.page.Devices === true && <DeviceList />}
                    {context.page.Organizations === true && <UserList />}
                    {context.page.Settings === true && <AdminSetting />}
                    {context.page.userDetail === true && <UserDetail />}
                    {context.page.deviceDetail === true && <DeviceDetail />}
                    {context.page.ManufacturedDevices === true && (
                      <ManufacturedDevice />
                    )}
                    {context.page.Hubs === true && <Hublist />}
                    {context.page.HubDevices === true && <HubDevices />}
                    {context.page.Admins === true && <AdminList />}
                    {context.page.Distributors === true && <Distributorlist />}
                    {context.page.replaceDevice === true && <ReplaceDevice />}
                    {context.page.ChangeBillingType === true && (
                      <ChangeBillingType />
                    )}
                    {context.page.CustomerBilling === true && (
                      <CustomerBilling />
                    )}
                  </Grid>
                </Grid>
              </Box>
            </adminDrawerContext.Provider>
          )}
        </>
      ) : (
        alert("You do not have permission to access this resource.")
      )}
    </>
  );
}
